import { select, Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { BaseDataSource, QueryResultsModel } from "../../_base/crud";
import { selectWarehouseAdjustmentQueryResult, selectWarehouseAdjustmentsPageLoading, selectWarehouseAdjustmentsShowInitWaitingMessage } from "../_selectors/warehouse-adjustment.selectors";

export class WarehouseAdjustmentsDataSource extends BaseDataSource {
    trashed = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectWarehouseAdjustmentsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectWarehouseAdjustmentsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectWarehouseAdjustmentQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        })
        
    }
}